const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

        {   
            const actionPath = 'actions/get-unbxd-add-to-cart-product.action';
            binding.dataActions[actionPath] = require('partner/actions/get-unbxd-add-to-cart-product.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-unbxd-product-recommendations.action';
            binding.dataActions[actionPath] = require('partner/actions/get-unbxd-product-recommendations.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-unbxd-recommendations-count.action';
            binding.dataActions[actionPath] = require('partner/actions/get-unbxd-recommendations-count.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-unbxd-remove-from-cart-product.action';
            binding.dataActions[actionPath] = require('partner/actions/get-unbxd-remove-from-cart-product.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/pdp-click-collect-modal-state.action';
            binding.dataActions[actionPath] = require('partner/actions/pdp-click-collect-modal-state.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/dobbies-category-page-summary/dobbies-category-page-summary.action';
            binding.dataActions[actionPath] = require('partner/modules/dobbies-category-page-summary/dobbies-category-page-summary.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/dobbies-default-general-page-summary/dobbies-default-general-page-summary.action';
            binding.dataActions[actionPath] = require('partner/modules/dobbies-default-general-page-summary/dobbies-default-general-page-summary.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/dobbies-product-page-summary/dobbies-product-page-summary.action';
            binding.dataActions[actionPath] = require('partner/modules/dobbies-product-page-summary/dobbies-product-page-summary.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'themes/dobbies/actions/get-availabilities-cartlines.override.action';
            binding.dataActions[actionPath] = require('partner/themes/dobbies/actions/get-availabilities-cartlines.override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'themes/dobbies/actions/get-categories-hierarchy.override.action';
            binding.dataActions[actionPath] = require('partner/themes/dobbies/actions/get-categories-hierarchy.override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'themes/dobbies/actions/get-current-category-hierarchy.override.action';
            binding.dataActions[actionPath] = require('partner/themes/dobbies/actions/get-current-category-hierarchy.override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'themes/dobbies/actions/get-customer-address.action';
            binding.dataActions[actionPath] = require('partner/themes/dobbies/actions/get-customer-address.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'themes/dobbies/actions/get-feature-state.override.action';
            binding.dataActions[actionPath] = require('partner/themes/dobbies/actions/get-feature-state.override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'themes/dobbies/actions/get-full-available-inventory-nearby.override.action';
            binding.dataActions[actionPath] = require('partner/themes/dobbies/actions/get-full-available-inventory-nearby.override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'themes/dobbies/actions/get-loyalty-card.override.action';
            binding.dataActions[actionPath] = require('partner/themes/dobbies/actions/get-loyalty-card.override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'themes/dobbies/actions/get-product-availabilities-for-selected-variant.override.action';
            binding.dataActions[actionPath] = require('partner/themes/dobbies/actions/get-product-availabilities-for-selected-variant.override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'themes/dobbies/actions/get-product-availabilities-for-unbxd.action';
            binding.dataActions[actionPath] = require('partner/themes/dobbies/actions/get-product-availabilities-for-unbxd.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'themes/dobbies/actions/get-products-in-active-cart.override.action';
            binding.dataActions[actionPath] = require('partner/themes/dobbies/actions/get-products-in-active-cart.override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'themes/dobbies/actions/get-ratings-summary.override.action';
            binding.dataActions[actionPath] = require('partner/themes/dobbies/actions/get-ratings-summary.override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'themes/dobbies/actions/get-selected-variant.override.action';
            binding.dataActions[actionPath] = require('partner/themes/dobbies/actions/get-selected-variant.override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'themes/dobbies/actions/get-store-location-information.override.action';
            binding.dataActions[actionPath] = require('partner/themes/dobbies/actions/get-store-location-information.override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'themes/dobbies/actions/get-unbxd-product.action';
            binding.dataActions[actionPath] = require('partner/themes/dobbies/actions/get-unbxd-product.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'themes/dobbies/actions/unx-req-id-data.action';
            binding.dataActions[actionPath] = require('partner/themes/dobbies/actions/unx-req-id-data.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'themes/dobbies/actions/update-primary-address.override.action';
            binding.dataActions[actionPath] = require('partner/themes/dobbies/actions/update-primary-address.override.action');
            registerActionId(actionPath);
        }

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.packageDataActions = {};
        window.__bindings__.packageDataActions['__local__'] = {
            ...binding.dataActions
        };